import React, { useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useSelector } from 'react-redux';
import FixedButton from './FixedButton';
import MobileNavigation from './MobileNavigation';
import { useNavigate } from 'react-router-dom';

function TermsConditions() {
  const sidebarState = useSelector(state => state.sidebarReducres);
  const navigate = useNavigate();
  useEffect(()=>{
      if(!localStorage.getItem('tokan')){
          navigate('/login');
      }
  }, []);
  return (
    <>
        <div className={`main-content ${!sidebarState ? '' : 'navbar-ful'}`}>
            <div className='page-content'>
                <Container fluid>
                    <Row>
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                            <h4 className='mb-3'>Terms and Conditions</h4>
                            <hr></hr>
                            <h5 class="mb-3">Introduction</h5>
                            <p>
                            These Terms and Conditions govern your use of Packers Billing software and its related services operated by [<b>Packers Billing</b>]. By accessing or using our software, you agree to abide by these Terms and Conditions in full. If you disagree with any part of these Terms and Conditions, you must not use our software.
                            </p>

                            <h5 class="mb-3">License to Use</h5>
                            <p>
                            Our software grants you a limited, non-exclusive, non-transferable license to use the software solely for your internal business purposes. You may not sublicense, sell, or distribute the software without prior written consent.
                            </p>

                            <h5 class="mb-3">Billing and Payments</h5>
                            <p>
                            You agree to pay all fees and charges incurred in connection with your use of our software. Prices are subject to change at any time without notice. Failure to pay may result in suspension or termination of your account.
                            </p>

                            <h5 class="mb-3">Data Security</h5>
                            <p>
                            We take data security seriously and implement measures to protect your information. However, we cannot guarantee absolute security and assume no liability for unauthorized access, disclosure, or loss of data.
                            </p>

                            <h5 class="mb-3">Intellectual Property</h5>
                            <p>
                            All intellectual property rights related to the software are owned by [<b>Packers Billing</b>]. You may not copy, modify, or distribute any part of the software without our prior written consent.
                            </p>

                            <h5 class="mb-3">Limitation of Liability</h5>
                            <p>
                            We shall not be liable for any direct, indirect, incidental, special, or consequential damages arising out of or in any way connected with your use of our software.
                            </p>

                            <h5 class="mb-3">Termination</h5>
                            <p>
                            We reserve the right to terminate or suspend your access to the software at any time for any reason without prior notice.
                            </p>

                            <h5 class="mb-3">Governing Law</h5>
                            <p>
                            These Terms and Conditions shall be governed by and construed in accordance with the laws of [<b>India</b>].
                            </p>

                            <h5 class="mb-3">Changes to Terms and Conditions</h5>
                            <p>
                            We reserve the right to modify or replace these Terms and Conditions at any time without notice. It is your responsibility to review this document periodically for changes.
                            </p>

                            <h5 class="mb-3">Contact Us</h5>
                            <p>
                            If you have any questions about these Terms and Conditions, please contact us at [<b><a href="mailto:support@packersbilling.in">support@packersbilling.in</a></b>].
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>
            <MobileNavigation/>
        </div>
    </>
  )
}

export default TermsConditions
